const GooglePlayIcon = ({ ...props }) => {
  return (
    <svg width="180" height="52" viewBox="0 0 180 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M173.333 52H6.66667C3.00167 52 0 49.0734 0 45.5V6.5C0 2.92663 3.00167 2.74817e-06 6.66667 2.74817e-06H173.333C176.998 2.74817e-06 180 2.92663 180 6.5V45.5C180 49.0734 176.998 52 173.333 52Z"
        fill="black"
      />
      <path
        d="M173.333 1.04162C176.42 1.04162 178.932 3.4905 178.932 6.5V45.5C178.932 48.5095 176.42 50.9584 173.333 50.9584H6.66667C3.58 50.9584 1.06833 48.5095 1.06833 45.5V6.5C1.06833 3.4905 3.58 1.04162 6.66667 1.04162H173.333ZM173.333 2.74817e-06H6.66667C3.00167 2.74817e-06 0 2.92663 0 6.5V45.5C0 49.0734 3.00167 52 6.66667 52H173.333C176.998 52 180 49.0734 180 45.5V6.5C180 2.92663 176.998 2.74817e-06 173.333 2.74817e-06Z"
        fill="#A6A6A6"
      />
      <path
        d="M13.9133 9.80032C13.5216 10.2001 13.2949 10.8224 13.2949 11.6284V40.3779C13.2949 41.1839 13.5216 41.8063 13.9133 42.2061L14.0099 42.2938L30.5332 26.1901V25.8098L14.0099 9.70607L13.9133 9.80032Z"
        fill="url(#paint0_linear_1195_312070)"
      />
      <path
        d="M36.0349 31.5607L30.5332 26.19V25.8098L36.0415 20.4392L36.1649 20.509L42.6882 24.1279C44.5499 25.1549 44.5499 26.8449 42.6882 27.8784L36.1649 31.4908L36.0349 31.5607Z"
        fill="url(#paint1_linear_1195_312070)"
      />
      <path
        d="M36.1657 31.4908L30.5341 26L13.9141 42.2061C14.5324 42.8398 15.5407 42.9162 16.6874 42.2825L36.1657 31.4908Z"
        fill="url(#paint2_linear_1195_312070)"
      />
      <path
        d="M36.1657 20.5091L16.6874 9.71751C15.5407 9.09025 14.5324 9.16663 13.9141 9.80038L30.5341 26L36.1657 20.5091Z"
        fill="url(#paint3_linear_1195_312070)"
      />
      <path
        d="M63.2234 13.3168C63.2234 14.4023 62.8901 15.2717 62.2334 15.9201C61.4784 16.6887 60.4951 17.0754 59.2901 17.0754C58.1384 17.0754 57.155 16.6822 56.3484 15.9071C55.54 15.1206 55.1367 14.1553 55.1367 12.9999C55.1367 11.8446 55.54 10.8793 56.3484 10.0993C57.155 9.31769 58.1384 8.92444 59.2901 8.92444C59.8634 8.92444 60.41 9.03981 60.9317 9.25431C61.4517 9.47044 61.875 9.76294 62.1817 10.1237L61.4851 10.8094C60.95 10.1936 60.2217 9.88969 59.2901 9.88969C58.4501 9.88969 57.7217 10.1757 57.1034 10.7526C56.4917 11.3311 56.185 12.0802 56.185 12.9999C56.185 13.9197 56.4917 14.6753 57.1034 15.2538C57.7217 15.8242 58.4501 16.1167 59.2901 16.1167C60.1817 16.1167 60.9317 15.8242 61.5234 15.2473C61.9134 14.8654 62.1351 14.3389 62.1934 13.6662H59.2901V12.7269H63.1634C63.2101 12.9301 63.2234 13.1267 63.2234 13.3168Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M69.3676 10.0603H65.7292V12.5303H69.0092V13.4695H65.7292V15.9395H69.3676V16.8966H64.6992V9.10315H69.3676V10.0603Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M73.705 16.8966H72.675V10.0603H70.4434V9.10315H75.9384V10.0603H73.705V16.8966Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M79.916 16.8966V9.10315H80.9444V16.8966H79.916Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M85.5019 16.8966H84.4802V10.0603H82.2402V9.10315H87.7419V10.0603H85.5019V16.8966Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M98.1446 15.8941C97.3563 16.6822 96.3796 17.0754 95.2146 17.0754C94.0429 17.0754 93.0663 16.6822 92.2779 15.8941C91.4913 15.1076 91.0996 14.1423 91.0996 12.9999C91.0996 11.8576 91.4913 10.8923 92.2779 10.1058C93.0663 9.31769 94.0429 8.92444 95.2146 8.92444C96.3729 8.92444 97.3496 9.31769 98.138 10.1123C98.9313 10.9053 99.3229 11.8641 99.3229 12.9999C99.3229 14.1423 98.9313 15.1076 98.1446 15.8941ZM93.0396 15.2408C93.6329 15.8242 94.3546 16.1167 95.2146 16.1167C96.0679 16.1167 96.7963 15.8242 97.3829 15.2408C97.9746 14.6574 98.2746 13.9083 98.2746 12.9999C98.2746 12.0916 97.9746 11.3424 97.3829 10.7591C96.7963 10.1757 96.0679 9.88319 95.2146 9.88319C94.3546 9.88319 93.6329 10.1757 93.0396 10.7591C92.4479 11.3424 92.1479 12.0916 92.1479 12.9999C92.1479 13.9083 92.4479 14.6574 93.0396 15.2408Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M100.768 16.8966V9.10315H102.018L105.904 15.1644H105.949L105.904 13.6661V9.10315H106.933V16.8966H105.859L101.789 10.5364H101.744L101.789 12.0411V16.8966H100.768Z"
        fill="white"
        stroke="white"
        strokeWidth="0.16"
        strokeMiterlimit="10"
      />
      <path
        d="M90.8474 28.2783C87.7157 28.2783 85.1574 30.602 85.1574 33.8082C85.1574 36.9883 87.7157 39.3364 90.8474 39.3364C93.9857 39.3364 96.544 36.9883 96.544 33.8082C96.544 30.602 93.9857 28.2783 90.8474 28.2783ZM90.8474 37.1589C89.129 37.1589 87.6507 35.776 87.6507 33.8082C87.6507 31.8143 89.129 30.4558 90.8474 30.4558C92.5657 30.4558 94.0507 31.8143 94.0507 33.8082C94.0507 35.776 92.5657 37.1589 90.8474 37.1589ZM78.4324 28.2783C75.294 28.2783 72.7424 30.602 72.7424 33.8082C72.7424 36.9883 75.294 39.3364 78.4324 39.3364C81.569 39.3364 84.1224 36.9883 84.1224 33.8082C84.1224 30.602 81.569 28.2783 78.4324 28.2783ZM78.4324 37.1589C76.7124 37.1589 75.229 35.776 75.229 33.8082C75.229 31.8143 76.7124 30.4558 78.4324 30.4558C80.1507 30.4558 81.629 31.8143 81.629 33.8082C81.629 35.776 80.1507 37.1589 78.4324 37.1589ZM63.659 29.9732V32.3229H69.414C69.2457 33.6359 68.7957 34.6012 68.1057 35.2739C67.2657 36.0864 65.9574 36.9883 63.659 36.9883C60.1174 36.9883 57.344 34.2014 57.344 30.7483C57.344 27.2952 60.1174 24.5083 63.659 24.5083C65.574 24.5083 66.9674 25.2379 67.9957 26.1837L69.694 24.5278C68.2557 23.1888 66.3424 22.1602 63.659 22.1602C58.8024 22.1602 54.7207 26.013 54.7207 30.7483C54.7207 35.4835 58.8024 39.3364 63.659 39.3364C66.284 39.3364 68.2557 38.4979 69.8057 36.9249C71.394 35.3763 71.889 33.1988 71.889 31.4405C71.889 30.8945 71.8424 30.3924 71.759 29.9732H63.659ZM124.069 31.7948C123.601 30.5582 122.156 28.2783 119.212 28.2783C116.296 28.2783 113.867 30.5192 113.867 33.8082C113.867 36.9054 116.271 39.3364 119.492 39.3364C122.097 39.3364 123.601 37.7878 124.219 36.8859L122.286 35.6298C121.641 36.5495 120.762 37.1589 119.492 37.1589C118.231 37.1589 117.326 36.595 116.746 35.4835L124.331 32.4237L124.069 31.7948ZM116.336 33.6359C116.271 31.5039 118.034 30.4119 119.297 30.4119C120.287 30.4119 121.127 30.8945 121.407 31.5852L116.336 33.6359ZM110.171 39H112.664V22.75H110.171V39ZM106.087 29.51H106.004C105.444 28.8633 104.376 28.2783 103.022 28.2783C100.182 28.2783 97.5857 30.7093 97.5857 33.826C97.5857 36.9249 100.182 39.3364 103.022 39.3364C104.376 39.3364 105.444 38.7465 106.004 38.0803H106.087V38.8733C106.087 40.9874 104.929 42.1233 103.061 42.1233C101.537 42.1233 100.592 41.0508 100.202 40.1489L98.034 41.0313C98.659 42.497 100.314 44.3008 103.061 44.3008C105.984 44.3008 108.451 42.6238 108.451 38.5434V28.6147H106.087V29.51ZM103.236 37.1589C101.517 37.1589 100.079 35.7565 100.079 33.826C100.079 31.8777 101.517 30.4558 103.236 30.4558C104.929 30.4558 106.264 31.8777 106.264 33.826C106.264 35.7565 104.929 37.1589 103.236 37.1589ZM135.742 22.75H129.779V39H132.266V32.8429H135.742C138.504 32.8429 141.212 30.8945 141.212 27.7957C141.212 24.6984 138.497 22.75 135.742 22.75ZM135.807 30.5825H132.266V25.0104H135.807C137.664 25.0104 138.724 26.5135 138.724 27.7957C138.724 29.0534 137.664 30.5825 135.807 30.5825ZM151.179 28.2474C149.382 28.2474 147.514 29.0209 146.746 30.7353L148.952 31.6372C149.427 30.7353 150.301 30.4428 151.224 30.4428C152.514 30.4428 153.822 31.1984 153.842 32.5325V32.7032C153.392 32.4497 152.429 32.0743 151.244 32.0743C148.867 32.0743 146.446 33.3499 146.446 35.7305C146.446 37.908 148.392 39.3104 150.581 39.3104C152.254 39.3104 153.177 38.5743 153.757 37.7179H153.842V38.974H156.244V32.7405C156.244 29.8594 154.037 28.2474 151.179 28.2474ZM150.879 37.1524C150.066 37.1524 148.932 36.7592 148.932 35.776C148.932 34.5183 150.346 34.0357 151.569 34.0357C152.664 34.0357 153.177 34.2713 153.842 34.5817C153.647 36.0864 152.319 37.1524 150.879 37.1524ZM164.994 28.6033L162.136 35.6477H162.051L159.096 28.6033H156.414L160.854 38.4475L158.321 43.9254H160.919L167.761 28.6033H164.994ZM142.579 39H145.072V22.75H142.579V39Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1195_312070"
          x1="29.0662"
          y1="40.6773"
          x2="7.25605"
          y2="18.308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1195_312070"
          x1="45.1124"
          y1="25.9981"
          x2="12.8499"
          y2="25.9981"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1195_312070"
          x1="33.1034"
          y1="23.015"
          x2="3.52709"
          y2="-7.31963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1195_312070"
          x1="9.73046"
          y1="51.7709"
          x2="22.9376"
          y2="38.2253"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GooglePlayIcon;
